import React from "react";
import Swal from "sweetalert2";
import ServiceAPI from "../services/NavaService";
import moment from 'moment';

export default function SignUpForm({ onSuccess, onSwitch }) {
    const [state, setState] = React.useState({
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        phoneNumber: ""
    });

    const handleChange = (evt) =>
        setState({ ...state, [evt.target.name]: evt.target.value });

    const showAlert = (text, icon = "info") => {
        if (typeof Swal !== "undefined" && Swal.fire) {
            Swal.fire({ text, icon, confirmButtonText: "OK" });
        } else {
            alert(text);
        }
    };

    const passwordsMatch =
        state.password !== "" && state.password === state.confirmPassword;
    const emailProvided = state.email && state.email.trim() !== "";
    const canSubmit = emailProvided && passwordsMatch;

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();

        const payload = {
            firstName: state.firstName || null,
            middleName: state.middleName || null,
            lastName: state.lastName || null,
            email: state.email,
            username: state.email,
            password: state.password,
            phoneNumber: state.phoneNumber || null,
        };

        try {

            const res = await ServiceAPI.signUp(payload);

            const messageText = res?.data.message || JSON.stringify(res);
            const usrId = res?.data.userId;

            if (messageText && messageText.includes("User registered successfully!")) {

                const rolePayload = {
                    usrId: usrId,
                    adminYn: 'N',
                    createdBy: state.email,
                    createdDate: moment().format('YYYY-MM-DD')
                };

                await ServiceAPI.postAuthUserRoles(rolePayload);

                showAlert("User registered successfully!", "success");
                setState({
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: ""
                });
                if (typeof onSuccess === "function") onSuccess("Sign in with your created email");
            } else {
                showAlert(messageText || "Sign up failed", "error");
            }
        } catch (err) {
            console.error("signup error", err);
            showAlert("Network error — could not sign up", "error");
        }
    };

    return (
        <div className="nava-auth-form-container nava-auth-signup">
            <div className="form-content">
                <form onSubmit={handleOnSubmit} autoComplete="off">
                    <h1>Create Account</h1>
                    <input
                        type="text"
                        name="firstName"
                        placeholder="First name"
                        value={state.firstName}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last name"
                        value={state.lastName}
                        onChange={handleChange}
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={state.email}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="tel"
                        name="phoneNumber"
                        placeholder="Phone number"
                        value={state.phoneNumber}
                        onChange={handleChange}
                    />

                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={state.password}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm password"
                        value={state.confirmPassword}
                        onChange={handleChange}
                        required
                    />

                    {!passwordsMatch && state.confirmPassword.length > 0 && (
                        <div style={{ color: "#c53030", fontSize: 13, marginTop: 6 }}>
                            Passwords do not match
                        </div>
                    )}

                    <button
                        type="submit"
                        className="nava-auth-submit"
                        disabled={!canSubmit}
                        style={{
                            opacity: canSubmit ? 1 : 0.6,
                            cursor: canSubmit ? "pointer" : "not-allowed",
                            marginTop: 16,
                        }}
                    >
                        Sign Up
                    </button>

                    <div className="mobile-switch">
                        <button
                            type="button"
                            className="nava-auth-switch"
                            onClick={() => onSwitch("signIn")}
                        >
                             Already a member? Log In
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
